import {
  Dialog as MuiDialog,
  DialogActions as MuiDialogActions,
  DialogContent as MuiDialogContent,
  styled,
} from '@mui/material';

import { generateClasses } from '../../utils/helper';

export const dialogClasses = {
  ...generateClasses('Dialog', ['root', 'hasContainer', 'container', 'paper', 'header', 'body', 'footer']),
};

export const StyledMuiDialog = styled(MuiDialog)(({ theme }) => ({
  [`&.${dialogClasses.hasContainer}`]: {
    position: 'absolute',
  },
  [`& .${dialogClasses.paper}`]: {
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 8,
  },
}));

export const DialogContent = styled(MuiDialogContent)(({ theme }) => ({
  padding: theme.spacing(5),
}));

export const DialogActions = styled(MuiDialogActions)(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.grey[200]}`,
}));
